import { render, staticRenderFns } from "./RequestSummary.view.vue?vue&type=template&id=71fb77ed&"
import script from "./RequestSummary.view.vue?vue&type=script&lang=js&"
export * from "./RequestSummary.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports